module.exports = __webpack_public_path__ + "static/media/disclaimer.bbaf72da.svg";